import { Form, Formik } from 'formik';
import { useEffect, useRef, useState } from 'react';
import EmailEditor from 'react-email-editor';
import { TextBox } from '../../../shared/controls/form';
import apiServices from '../../../services/service';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import SelectBox from '../../../shared/controls/form/selectBox';
import 'react-tooltip/dist/react-tooltip.css';
import Loader from '../../../shared/component/Loader';
import { fetchDataAndUpdateStore } from '../../../redux/actions';

const EmailTemplateBuilder = () => {
  const location = useLocation();
  const emailEditorRef = useRef(null);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    subject: '', // Avoid undefined values
    name: '', // Provide default values
  });
  const [errormsg, setErrorMsg] = useState({});
  const [variables, setVariables] = useState([]);
  const [emailEditorData, setEmailEditorData] = useState();
  const navigate = useNavigate();
  const [formEdited, setFormEdited] = useState(false);
  const handleBack = () => {
    navigate(-1);
  };

  const handleChangeForm = (e) => {
    const { name, value } = e.target;
    // Restrict input for specific fields
    let convertedValue = value;
    // Clear the error message for the field being edited
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));

    // Update form data
    setFormData({
      ...formData,
      [name]: convertedValue,
    });

    setFormEdited(true);
  };

  const handleChangeCheckbox = (e) => {
    const { name, checked } = e.target; // Use 'checked' for true/false value
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: checked, // Set the checkbox state as true/false
    }));
    setFormEdited(true);
  };

  const options = [
    { label: 'AI Agent', value: 'AI Agent' },
    { label: 'AQ', value: 'AQ' },
    { label: 'AS400', value: 'AS400' },
    { label: 'BPO', value: 'BPO' },
    { label: 'Claims', value: 'Claims' },
    { label: 'Digital Transformation', value: 'Digital Transformation' },
    { label: 'IT Services', value: 'IT Services' },
    { label: 'Newsletter', value: 'Newsletter' },
    { label: 'RPA', value: 'RPA' },
    { label: 'Event', value: 'Event' },
  ];

  useEffect(() => {
    if (location.state) {
      if (location.state.data) {
        setFormData({
          id: location.state.data.id,
          module: location.state.module,
          name: location.state.data.name,
          subject: location.state.data.subject,
          contentHtml: location.state.data.contentHtml,
          contentJson: location.state.data.contentJson,
          publicTemplate: location.state.data.publicTemplate == 'true',
          usageCount: location.state.data.usageCount,
          templateType: location.state.data.templateType,
          type: location.state.data.type,
        });
        setEmailEditorData(location.state.data);
      } else {
        setFormData({
          module: location.state.module,
          name: '',
          subject: '',
          publicTemplate: false,
          usageCount: '',
          templateType: 'AI Agent',
        });
      }
      let tags = [];
      switch (location.state.module) {
        case 'Lead':
          tags = [
            { name: 'Company Name', value: '{{companyName}}' },
            { name: 'Display Name', value: '{{displayName}}' },
            { name: 'Short Name', value: '{{shortName}}' },
            { name: 'Phone', value: '{{phone}}' },
            { name: 'Alternate Phone', value: '{{alternatePhone}}' },
            { name: 'Time Zone', value: '{{timeZone}}' },
            { name: 'Salutation', value: '{{salutation}}' },
            { name: 'Company LinkedIn', value: '{{companyLinkedIn}}' },
            { name: 'Website', value: '{{website}}' },
            { name: 'Annual Revenue', value: '{{annualRevenue}}' },
            { name: 'Revenue Type ID', value: '{{revenueTypeId}}' },
            { name: 'Revenue Type', value: '{{revenueType}}' },
            { name: 'No. of Employees', value: '{{noOfEmployees}}' },
            { name: 'No. of Beds', value: '{{noOfBeds}}' },
            { name: 'Business Type', value: '{{businessType}}' },
            { name: 'Industry', value: '{{industry}}' },
            { name: 'Line of Business', value: '{{lineOfBusiness}}' },
            { name: 'Lead Source', value: '{{leadSource}}' },
            { name: 'Source Name', value: '{{sourceName}}' },
            { name: 'Other Source Name', value: '{{otherSourceName}}' },
            { name: 'Owner', value: '{{owner}}' },
            { name: 'First Name', value: '{{firstName}}' },
            { name: 'Middle Name', value: '{{middleName}}' },
            { name: 'Last Name', value: '{{lastName}}' },
            { name: 'Full Name', value: '{{fullName}}' },
            { name: 'Title', value: '{{title}}' },
            { name: 'Email', value: '{{email}}' },
            { name: 'Secondary Email', value: '{{secondaryEmail}}' },
            { name: 'Direct Phone', value: '{{directPhone}}' },
            { name: 'Mobile', value: '{{mobile}}' },
            { name: 'Contact LinkedIn', value: '{{contactLinkedIn}}' },
            { name: 'Street', value: '{{street}}' },
            { name: 'City', value: '{{city}}' },
            { name: 'State', value: '{{state}}' },
            { name: 'Zip Code', value: '{{zipCode}}' },
            { name: 'Country', value: '{{country}}' },
            { name: 'Description', value: '{{description}}' },
            { name: 'Technology Details', value: '{{technologyDetails}}' },
            { name: 'Written Premium', value: '{{writtenPremium}}' },
            { name: 'Member Status', value: '{{memberStatus}}' },
            { name: 'Created By', value: '{{createdBy}}' },
            { name: 'Updated By', value: '{{updatedBy}}' },
            { name: 'Created Date', value: '{{createdDateTime}}' },
            { name: 'Updated Date', value: '{{updatedDateTime}}' },
          ];
          break;
        case 'Contact':
          tags = [
            { name: 'Name', value: '{{name}}' },
            { name: 'Display Name', value: '{{displayName}}' },
            { name: 'Short Name', value: '{{shortName}}' },
            { name: 'Description', value: '{{description}}' },
            { name: 'Tags', value: '{{tags}}' },
            { name: 'Owner', value: '{{owner}}' },
            { name: 'Lead Source', value: '{{leadSource}}' },
            { name: 'First Name', value: '{{firstName}}' },
            { name: 'Middle Name', value: '{{middleName}}' },
            { name: 'Last Name', value: '{{lastName}}' },
            { name: 'Full Name', value: '{{fullName}}' },
            { name: 'Title', value: '{{title}}' },
            { name: 'Salutation', value: '{{salutation}}' },
            { name: 'Salutation ID', value: '{{salutationId}}' },
            { name: 'Email', value: '{{email}}' },
            { name: 'Secondary Email', value: '{{secondaryEmail}}' },
            { name: 'Department', value: '{{department}}' },
            { name: 'Account', value: '{{account}}' },
            { name: 'Phone', value: '{{phone}}' },
            { name: 'Mobile', value: '{{mobile}}' },
            { name: 'Reporting To', value: '{{reportingTo}}' },
            { name: 'Assistant', value: '{{assistant}}' },
            { name: 'Assistant Phone', value: '{{assistantPhone}}' },
            { name: 'Contact Person Role', value: '{{contactPersonRole}}' },
            { name: 'LinkedIn', value: '{{linkedin}}' },
            { name: 'Twitter', value: '{{twitter}}' },
            { name: 'Facebook', value: '{{facebook}}' },
            { name: 'Skype ID', value: '{{skypeId}}' },
            { name: 'Street', value: '{{street}}' },
            { name: 'City', value: '{{city}}' },
            { name: 'State', value: '{{state}}' },
            { name: 'Zip Code', value: '{{zipCode}}' },
            { name: 'Country', value: '{{country}}' },
            { name: 'Technology Stack', value: '{{technologyStack}}' },
            { name: 'Created By', value: '{{createdBy}}' },
            { name: 'Updated By', value: '{{updatedBy}}' },
            { name: 'Created Date', value: '{{createdDateTime}}' },
            { name: 'Updated Date', value: '{{updatedDateTime}}' },
          ];
          break;
        case 'Account':
          tags = [
            { name: 'Parent Account ID', value: '{{parentAccountId}}' },
            { name: 'Name', value: '{{name}}' },
            { name: 'Display Name', value: '{{displayName}}' },
            { name: 'Short Name', value: '{{shortName}}' },
            { name: 'Description', value: '{{description}}' },
            { name: 'Tags', value: '{{tags}}' },
            { name: 'Industry ID', value: '{{industryId}}' },
            { name: 'Industry Type', value: '{{industryType}}' },
            { name: 'Owner', value: '{{owner}}' },
            { name: 'Owner ID', value: '{{ownerId}}' },
            { name: 'Lead ID', value: '{{leadId}}' },
            { name: 'Lead', value: '{{lead}}' },
            { name: 'Account Type ID', value: '{{accountTypeId}}' },
            { name: 'Account Type', value: '{{accountType}}' },
            { name: 'Phone', value: '{{phone}}' },
            { name: 'Company LinkedIn', value: '{{companyLinkedIn}}' },
            { name: 'Website', value: '{{website}}' },
            { name: 'Employees', value: '{{employees}}' },
            { name: 'Annual Revenue', value: '{{annualRevenue}}' },
            { name: 'No. of Beds', value: '{{noOfBeds}}' },
            { name: 'Street', value: '{{street}}' },
            { name: 'City', value: '{{city}}' },
            { name: 'State', value: '{{state}}' },
            { name: 'Zip Code', value: '{{zipCode}}' },
            { name: 'Country', value: '{{country}}' },
            { name: 'Technology Details', value: '{{technologyDetails}}' },
            { name: 'Created By', value: '{{createdBy}}' },
            { name: 'Created By ID', value: '{{createdById}}' },
            { name: 'Updated By', value: '{{updatedBy}}' },
            { name: 'Updated By ID', value: '{{updatedById}}' },
            { name: 'Created Date', value: '{{createdDateTime}}' },
            { name: 'Updated Date', value: '{{updatedDateTime}}' },
          ];
          break;
        case 'Opportunity':
          tags = [
            { name: 'Name', value: '{{name}}' },
            { name: 'Account ID', value: '{{accountId}}' },
            { name: 'Account Name', value: '{{accountName}}' },
            { name: 'Contact ID', value: '{{contactId}}' },
            { name: 'Contact Name', value: '{{contactName}}' },
            { name: 'Project Type ID', value: '{{projectTypeId}}' },
            { name: 'Project Type', value: '{{projectType}}' },
            { name: 'Next Step', value: '{{nextStep}}' },
            { name: 'Forecast Category ID', value: '{{forecastCategoryId}}' },
            { name: 'Forecast Category', value: '{{forecastCategory}}' },
            { name: 'Tags', value: '{{tags}}' },
            { name: 'Amount', value: '{{amount}}' },
            { name: 'Stage ID', value: '{{stageId}}' },
            { name: 'Stage', value: '{{stage}}' },
            { name: 'Probability', value: '{{probability}}' },
            { name: 'Closing Date', value: '{{closingDate}}' },
            { name: 'Expected Revenue', value: '{{expectedRevenue}}' },
            { name: 'Campaign Source', value: '{{campaignSource}}' },
            { name: 'Campaign Source ID', value: '{{campaignSourceId}}' },
            {
              name: 'Reach Out for Marketing',
              value: '{{reachOutForMarketing}}',
            },
            { name: 'Description', value: '{{description}}' },
            { name: 'Technology Stack', value: '{{technologyStack}}' },
            { name: 'Owner', value: '{{owner}}' },
            { name: 'Owner ID', value: '{{ownerId}}' },
            { name: 'Industry ID', value: '{{industryId}}' },
            { name: 'Industry', value: '{{industry}}' },
            { name: 'Business Type', value: '{{businessType}}' },
            { name: 'Lead Source ID', value: '{{leadSourceId}}' },
            { name: 'Lead Source', value: '{{leadSource}}' },
            { name: 'Source Name', value: '{{sourceName}}' },
            { name: 'Line of Business', value: '{{lineOfBusiness}}' },
            { name: 'Created By', value: '{{createdBy}}' },
            { name: 'Created By ID', value: '{{createdById}}' },
            { name: 'Updated By', value: '{{updatedBy}}' },
            { name: 'Updated By ID', value: '{{updatedById}}' },
            { name: 'Created Date', value: '{{createdDateTime}}' },
            { name: 'Updated Date', value: '{{updatedDateTime}}' },
          ];
          break;
        default:
          tags = [];
      }

      setVariables(tags);
    }
  }, [location]);

  const onLoad = () => {
    console.log('Email editor loaded.');

    if (location.state?.data?.contentJson) {
      const parsedJson = JSON.parse(location.state.data.contentJson);

      // Ensure the body text is left-aligned
      if (!parsedJson.body) {
        parsedJson.body = { style: { textAlign: 'left' } };
      } else {
        parsedJson.body.style = { textAlign: 'left' };
      }

      emailEditorRef.current.editor.loadDesign(parsedJson);
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const onReady = () => {
    console.log('Email editor is ready.');

    if (emailEditorRef.current) {
      emailEditorRef.current.editor.addEventListener('design:updated', () => {
        console.log('Design updated.');
        setFormEdited(true);
      });
    }
  };

  const handleSubmit = (formData) => {
    if (formData.name === '' && formData.subject === '') {
      toast.error('Please Enter Template Name & Subject Before Saving', {
        position: 'top-right',
      });
      return;
    }
    setLoading(true);
    if (emailEditorRef.current) {
      emailEditorRef.current.editor.exportHtml(async (data) => {
        const { design, html } = data;
        // Remove all <o:p></o:p> tags from the HTML
        const cleanedHtml = html.replace(/<o:p>.*?<\/o:p>/g, '');
        const tempData = {
          ...formData,
          contentHtml: cleanedHtml,
          contentJson: JSON.stringify(design),
          publicTemplate: formData.publicTemplate.toString(),
        };
        const { id, ...formDataWithoutId } = formData;
        const tempDataAdd = {
          ...formDataWithoutId,
          contentHtml: cleanedHtml,
          contentJson: JSON.stringify(design),
          publicTemplate: formData.publicTemplate.toString(),
        };
        if (location?.state?.data?.type === 'edit') {
          await apiServices
            .updateTemplate(tempData)
            .then((response) => {
              if (response.status === 200) {
                setLoading(false);
                toast.success('Template Created Successfully!', {
                  position: 'top-right',
                });
                dispatch(
                  fetchDataAndUpdateStore({
                    key: 'template',
                  })
                );
                navigate('/settings/templates', {
                  state: location.state.module,
                });
              }
            })
            .catch((error) => {
              console.error('Error creating Template:', error);
              toast.error('Failed to create Template.', {
                position: 'top-right',
              });
              setLoading(false);
            });
        } else {
          console.log(tempDataAdd);
          await apiServices
            .createTemplate(tempDataAdd)
            .then((response) => {
              if (response.status === 200) {
                setLoading(false);
                toast.success('Template Created Successfully!', {
                  position: 'top-right',
                });
                dispatch(
                  fetchDataAndUpdateStore({
                    key: 'template',
                  })
                );
                navigate('/settings/templates', {
                  state: location.state.module,
                });
              }
            })
            .catch((error) => {
              console.error('Error creating Template:', error);
              toast.error('Failed to create Template.', {
                position: 'top-right',
              });
              setLoading(false);
            });
        }
      });
    } else {
      console.error('EmailEditor is not initialized yet.');
      return;
    }
  };

  const handleSelect = (selected) => {
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      templateType: undefined,
    }));

    // Update form data
    setFormData({
      ...formData,
      templateType: selected.value,
    });
  };

  return (
    <>
      {/* <ToastContainer /> */}
      {loading && <Loader />}
      <div className="templateBuilderOuter">
        <div className="formContainer">
          <Formik initialValues={formData} onSubmit={(values) => handleSubmit(values)}>
            <Form>
              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="row align-items-center">
                    <div className="col-12 col-md-1">
                      <button
                        className="backButton"
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content="Back to Gallery"
                        data-tooltip-place="bottom"
                        onClick={handleBack}
                      >
                        <i className="bi bi-arrow-left"></i>
                      </button>
                    </div>
                    <div className="col-12 col-md-9 bdrLeft">
                      <div className="row align-items-center">
                        <div className="col-12 col-md-12">
                          <div className="inputContainer noLabel tName">
                            <TextBox
                              label={''}
                              name={'name'}
                              placeholder={'Enter a Template Name'}
                              value={formData?.name || ''}
                              handleChange={handleChangeForm}
                              maxLength={250}
                              errormsg={errormsg?.name}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-12">
                          <div className="inputContainer noLabel">
                            <TextBox
                              label={''}
                              name={'subject'}
                              placeholder={'Enter a Template Subject'}
                              value={formData?.subject || ''}
                              handleChange={handleChangeForm}
                              maxLength={250}
                              errormsg={errormsg?.subject}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6 align-self-center">
                  <div className="row align-items-center justify-content-end">
                    <div className="col-12 col-md-12">
                      <div className="d-flex align-items-center justify-content-end">
                        <div className="inputContainer-chk">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              name={'publicTemplate'}
                              checked={formData?.publicTemplate}
                              onChange={handleChangeCheckbox}
                              type="checkbox"
                              id="flexSwitchCheckChecked"
                            />
                            <label className="form-check-label" htmlFor="flexSwitchCheckChecked">
                              Public Template
                            </label>
                          </div>
                        </div>
                        <div className="inputContainer noLabel mx-4">
                          <SelectBox
                            name={'templateType'}
                            placeholder={formData?.templateType || 'Enter Template Type'}
                            options={options}
                            handleSelect={handleSelect}
                            maxLength={250}
                            errormsg={errormsg?.subject}
                          />
                        </div>
                        <div className="btnCT">
                          <button
                            type="button"
                            className="btn btn-outline-primary"
                            onClick={() => {
                              handleSubmit(formData);
                            }}
                            disabled={formData.type === 'edit' && !formEdited}
                          >
                            Save Template
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          </Formik>
        </div>

        <div className="editor">
          <EmailEditor
            ref={emailEditorRef}
            onLoad={onLoad}
            onReady={onReady}
            options={{
              displayMode: 'email',
              mergeTags: variables,
              customFonts: [
                {
                  label: 'Calibri',
                  value: 'Calibri',
                  url: 'https://fonts.cdnfonts.com/css/calibri',
                },
              ],
            }}
          />
        </div>
      </div>
    </>
  );
};

const predefinedTemplate = {
  body: {
    rows: [
      {
        cells: [1],
        columns: [
          {
            contents: [
              {
                type: 'text',
                values: {
                  text: '<h1>Welcome to Our Newsletter!</h1>',
                },
              },
            ],
          },
        ],
      },
    ],
  },
};

export default EmailTemplateBuilder;
